import { CompartmentCard } from "@/src/components/cards";
import { FetchableList } from "@/src/components/fetchableLists";
import { Hospitalisation, Intervention, Patient } from "@/src/data/allTypes";
import apiFetch from "@/src/utils/apiFetch";
import { getItemId, getUserId } from "@/src/utils/utils";
import { getStandardConfidentiality } from "../../patients/confidentialitiesHook";
import { openSnomedConceptPicker } from "../../snomed/SnomedConceptPicker";
import openEvolutionStandardForm from "../openEvolutionItemStandardForm";
import InterventionCard from "./interventionCard";
import { openEvolutionVisualisationDrawer } from "../openEvolutionVisualisation";
import { useState } from "react";

export function InterventionsCompartment({
  patient,
  parent,
}: {
  patient: Patient;
  parent: Hospitalisation;
}) {
  const [reload, setReload] = useState(0);
  async function addNewIntervention() {
    await openSnomedConceptPicker({
      title: "Choisir une intervention",
      parentIds: ["procedure"],
      category: "intervention",
      onSelect: async (reference) => {
        let item: Intervention = {
          type: "intervention",
          patient,
          creator: getUserId(),
          parent,
          reference,
          content: {
            patient,
            creator: getUserId(),
            fieldAnswers: [],
            reference: null,
          },
          confidentiality: getStandardConfidentiality(patient),
          readBy: [getUserId()],
        };
        await openEvolutionStandardForm({
          item,
          patient,
          onConfirm: async (newItem) => {
            newItem = await apiFetch("interventions", "addOne", {
              intervention: newItem,
            });
            setReload((prev) => prev + 1);
          },
        });
      },
    });
  }

  return (
    <CompartmentCard
      title={"Interventions"}
      onClick={async () => {
        await addNewIntervention();
      }}
    >
      <FetchableList
        queryKey={["InterventionsCompartment", getItemId(parent), reload]}
        queryFn={() =>
          apiFetch("interventions", "loadMany", {
            parentId: getItemId(parent),
          })
        }
      >
        {(data) => {
          return (
            <div className="grid c1 gap10">
              {data?.map((item, index) => {
                return (
                  <InterventionCard
                    key={item.id}
                    item={item}
                    patient={patient}
                    parent={parent}
                    onClick={async () => {
                      await openEvolutionVisualisationDrawer({
                        items: data!,
                        index,
                        patient,
                      });
                    }}
                    onChange={() => {
                      setReload((prev) => prev + 1);
                    }}
                  />
                );
              })}
            </div>
          );
        }}
      </FetchableList>
    </CompartmentCard>
  );
}
